export default __webpack_public_path__ + "static/media/500px.534e456f.svg";